import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const MarkerFillIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 15 19.5"
    >
      <g transform="translate(0.75 0.75)">
        <path
          d="M6.75,1279h0a50.347,50.347,0,0,1-3.374-4.028C1.835,1272.912,0,1270.036,0,1268.03A6.9,6.9,0,0,1,6.75,1261a6.9,6.9,0,0,1,6.75,7.03c0,2.006-1.835,4.882-3.375,6.941A50.347,50.347,0,0,1,6.751,1279Zm0-14.768a4.036,4.036,0,1,0,4.021,4.036A4.034,4.034,0,0,0,6.751,1264.232Z"
          transform="translate(0 -1261)"
          fill={color}
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
